import { render, staticRenderFns } from "./side-list.vue?vue&type=template&id=3d67e272&scoped=true"
import script from "./side-list.vue?vue&type=script&lang=js"
export * from "./side-list.vue?vue&type=script&lang=js"
import style0 from "./side-list.vue?vue&type=style&index=0&id=3d67e272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67e272",
  null
  
)

export default component.exports